module.exports = __webpack_public_path__ + "img/28.3b82db3b.png";